import { FC, useContext } from 'react'
import { useParsedProjectFile } from '../../../../queries/parsedProjectFile'
import { ModalComponents } from '../../../core/Modal'
import { ConfirmSoundsTable } from './components'
import { Loader } from './primitives'
import { RegisterModalContext } from './RegisterSongModal'

export const ConfirmSoundAttributionPage: FC = () => {
  const { state, setDetectedSubComponentIds } = useContext(RegisterModalContext)
  const parsedProjectFileQuery = useParsedProjectFile({
    projectFile: state.projectFileField.value!,
    options: {
      enabled: state.projectFileField.value !== undefined,
      refetchOnMount: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      onSuccess: (data) => {
        setDetectedSubComponentIds(data.subComponents.map((x) => x.id))
      }
    }
  })

  return (
    <>
      <ModalComponents.HeaderContainer>
        <ModalComponents.Title>Confirm Sound Attribution</ModalComponents.Title>
        <ModalComponents.Subtitle>
          Select the samples you used in your song from the list below. Your song's detail page will highlight these samples and each sample's detail page will include a link to your song.
      </ModalComponents.Subtitle>
      </ModalComponents.HeaderContainer>
      <ModalComponents.Container>
        {state.remixOfSamplePack && (
          <ModalComponents.SectionHeader>
            {state.remixOfSamplePack.title}
          </ModalComponents.SectionHeader>
        )}
        {parsedProjectFileQuery.isLoading && parsedProjectFileQuery.fetchStatus !== 'idle' ? (
          <Loader />
        ) : (
          <ConfirmSoundsTable />
        )}
      </ModalComponents.Container>
    </>
  )
}
